import { createContext, useContext } from 'react';
import noop from 'lodash/noop';
import type { BoardIssueOld } from '../../common/types';

// Remove entire folder when jwm.board-awesome-enhancements is cleaned up

export type IssueActionContextProps = {
	onIssueClick: (id: BoardIssueOld, withCmd: boolean) => void;
	onIssueDelete: (issue: BoardIssueOld) => void;
	isDeleteIssueAllowed: boolean;
};

const defaultActionsContext = {
	onIssueClick: noop,
	onIssueDelete: noop,
	isDeleteIssueAllowed: false,
};

const IssueActionsContext = createContext<IssueActionContextProps>(defaultActionsContext);

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const useIssueActionsContext = () => useContext(IssueActionsContext);

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export default IssueActionsContext;
